import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import {
  TextInput, Button, FlexColumn, Table, useRematchDispatch,
} from '@equifinance/shared';
import Page from '../components/Page';
import { RootState } from '../store';
import { Referral } from '../models/referralsModel';
import { ReferralReason } from '../models/referralReasonsModel';
import Chat from '../components/AccountForms/TasksForm/Chat';

const Container = styled(FlexColumn)`
  width:100%;
`;
const SubmitButton = styled(Button)`
  width:200px;
`;
const ChatContainer = styled.div`
  flex:1;
`;
export default function ReferralReasons() {
  const { id } = useParams() as {id: string};
  const dispatch = useRematchDispatch();
  const referral: Referral = useSelector(
    (rootState: RootState) => rootState.referrals[id],
  );
  const referralReasons: ReferralReason[] = useSelector(
    (rootState: RootState) => Object.values<ReferralReason>(rootState.referralReasons).filter<ReferralReason>(
      (referralReason): referralReason is ReferralReason => referralReason.referralId === id,
    ),
  );

  const onChangeNote = (referralReasonId: string, note: string) => {
    dispatch.referralReasons.UPDATE({ note }, referralReasonId);
  };

  const Note = (referralReason: ReferralReason) => useMemo(
    () => (
      <TextInput id="reason-input" placeholder="Enter Note..." value={referralReason.note} onChange={(value: string) => onChangeNote(referralReason.id, value)} />
    ),
    [referralReason],
  );

  const columns = [
    {
      name: 'Type',
      sortable: true,
      selector: (referralReason: ReferralReason) => referralReason.referralType,
    },
    {
      name: 'Note',
      sortable: true,
      cell: (referralReason: ReferralReason) => Note(referralReason),
    },
  ];

  return (
    <Page>
      <Container>
        <SubmitButton onClick={() => {}}>Submit Referral</SubmitButton>
        <Table
          columns={columns}
          data={referralReasons}
        />
        <ChatContainer>
          <Chat chatId={referral.chatId} />
        </ChatContainer>
      </Container>
    </Page>
  );
}
